import { bootManifestApp, loadBootManifestAppFromChannel } from "../../packages/platform-shell/src/index.js";
const loadPluginModule0 = () => import("../../platform/plugins/platform-auth-login/index.js");
import * as pluginModule1 from "../../apps/ttoria-control-centre/plugins/control-centre/index.js";
const appManifest = {
  "appId": "ttoria-control-centre",
  "appName": "TToria Control Centre",
  "runtime": "manifest-platform",
  "defaultTab": "control-centre",
  "defaultScreenId": "",
  "authPolicy": "required",
  "apiBaseUrl": "",
  "platformCore": {
    "mode": "workspace",
    "channel": "",
    "version": "",
    "minVersion": "",
    "manifestUrl": "",
    "rollbackVersion": ""
  },
  "uiTheme": {
    "appearanceId": "figma",
    "packId": "tutor-desk",
    "defaultPackId": "tutor-desk",
    "appScope": "ttoria-control-centre"
  },
  "shellPreset": "empty",
  "authBaseline": "with-auth-login",
  "shell": {
    "version": "v1",
    "layout": "sidebar-standard",
    "navMode": "plugin-tabs",
    "mobileNavMode": "stacked"
  },
  "baselines": [
    "platform.auth-login"
  ],
  "plugins": [
    "control-centre"
  ],
  "resourceIsolation": "strict-app",
  "dependencyProfile": "platform-auth-core-v2-zero-n8n-no-email",
  "dependencyExtensions": [
    "ttoria-control-centre-core",
    "cloudflare-direct-email"
  ],
  "previewAdapterId": "web-cloudflare-v1",
  "previewModes": [
    "demo-local",
    "real-local"
  ],
  "previewDataProfile": "default-demo-v1",
  "operations": {
    "ownerTeam": "platform",
    "serviceTier": "tier1",
    "reliabilityProfileId": "internal-critical-v1",
    "observabilityProfileId": "managed-cloudflare-v1",
    "deployPolicyId": "cloudflare-governed-v1",
    "runbookRefs": [
      "apps/ttoria-control-centre/docs/runbooks/control-centre-operations.md",
      "apps/ttoria-control-centre/docs/security-and-privacy-boundary.md"
    ]
  },
  "settingsPlugin": {
    "visiblePanelsByRole": {
      "default": [
        "appearance"
      ],
      "admin": [
        "users",
        "sessions",
        "audit",
        "usage",
        "appearance",
        "archive"
      ]
    },
    "appearanceScopePolicy": {
      "default": "runtime-eligible",
      "admin": "runtime-eligible"
    },
    "appContribution": null
  },
  "testingEngine": {
    "v2": {
      "executionMode": "v2-only",
      "primaryPilot": false,
      "secondaryReference": false,
      "enabledLanes": {
        "model": true,
        "shell": true,
        "pluginAction": true,
        "workflow": true,
        "uiConsistency": true,
        "stress": false
      },
      "sizePolicy": {
        "presubmitBias": "small-medium",
        "largeLaneMaxPercent": 10
      },
      "hermeticPolicy": {
        "enforceForSmall": true,
        "enforceForMedium": true
      },
      "confidencePolicy": {
        "requireCoverageClosure": true,
        "requireConfidenceClosure": true
      },
      "quarantinePolicy": {
        "ttlDays": 14,
        "requireOwner": true
      },
      "ciPolicy": {
        "requiredChecks": [
          "app-test-plan",
          "app-test-runtime-critical",
          "app-test-coverage-closure",
          "app-test-confidence-closure"
        ]
      },
      "artifactPolicy": {
        "traceMode": "on-first-retry",
        "screenshotMode": "only-on-failure",
        "videoMode": "retain-on-failure"
      },
      "runtimeBacked": {
        "shell": {
          "enabled": false,
          "maxCases": 6,
          "maxWallClockSharePct": 15
        },
        "pluginAction": {
          "enabled": false,
          "criticalOnly": true,
          "maxCases": 12,
          "maxWallClockSharePct": 20
        },
        "workflow": {
          "enabled": false,
          "criticalOnly": true,
          "maxCases": 8,
          "maxWallClockSharePct": 20
        },
        "uiConsistency": {
          "enabled": false,
          "maxCases": 12,
          "maxWallClockSharePct": 25
        }
      },
      "migrationPolicy": {
        "primaryPromotionGate": false,
        "defaultForNewApps": true,
        "promotionWindowDays": 14,
        "sunsetWindow": "1-release-cycle"
      }
    },
    "enabled": true,
    "enforcementMode": "mandatory",
    "language": "js",
    "runner": "node:test",
    "generationMode": "hybrid",
    "dataMode": "synthetic-deterministic-factory",
    "obsoletePolicy": "quarantine-then-purge",
    "gatePolicy": "warn-only",
    "networkPolicy": "deny",
    "budgets": {
      "maxUnitCasesPerBehavior": 3,
      "maxIntegrationCasesPerBoundary": 3,
      "maxWorkflowCasesPerWorkflow": 3,
      "maxStressCasesPerApp": 25,
      "fuzzNDefault": 10,
      "fuzzNMax": 50,
      "maxAiEnrichedCasesPerBehavior": 5,
      "maxTotalGeneratedCasesPerApp": 2000,
      "maxGeneratedFilesPerSuite": 2000,
      "maxPlanOperationsPerSync": 5000,
      "maxScenarioVariantsPerScenario": 4,
      "maxStructuralFallbackCasesPerBehavior": 1,
      "timeBudgetSeconds": {
        "unit": 60,
        "integration": 120,
        "workflow": 120,
        "stress": 180,
        "verification": 120
      },
      "stressProfile": "standard"
    },
    "golden": {
      "enabled": true,
      "mode": "strict",
      "required": true,
      "maxGoldenFailuresToShow": 20
    },
    "business": {
      "enabled": false,
      "structuralFallbackPolicy": "only-uncovered",
      "requireConcreteAssertions": true,
      "minBusinessCoverageRatio": 0.8
    }
  }
};
const shellRuntimeConfig = {
  "asyncFeedbackCatalog": {
    "contractId": "ttoria-saas-async-feedback-v1",
    "appId": "ttoria-control-centre",
    "operations": [
      {
        "action": "platform-shell.legacy-feedback.hidebusyoverlay.f52f9d09",
        "kind": "legacy-feedback",
        "opClass": "foreground-read",
        "target": {
          "id": "syncbusyoverlay",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "platform-shell-legacy-overlay",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.legacy-feedback.reconcilebusyoverlay.03ac407d",
        "kind": "legacy-feedback",
        "opClass": "foreground-read",
        "target": {
          "id": "showbusyoverlay",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "platform-shell-legacy-overlay",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.legacy-feedback.reconcilebusyoverlay.1875bf1c",
        "kind": "legacy-feedback",
        "opClass": "foreground-read",
        "target": {
          "id": "hidebusyoverlay",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "platform-shell-legacy-overlay",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.legacy-feedback.reconcilebusyoverlay.8d8b02ff",
        "kind": "legacy-feedback",
        "opClass": "foreground-read",
        "target": {
          "id": "hidebusyoverlay",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "platform-shell-legacy-overlay",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.legacy-feedback.reconcilebusyoverlay.a181481a",
        "kind": "legacy-feedback",
        "opClass": "foreground-read",
        "target": {
          "id": "showbusyoverlay",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "platform-shell-legacy-overlay",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.legacy-feedback.reconcilebusyoverlay.a7269fa7",
        "kind": "legacy-feedback",
        "opClass": "foreground-read",
        "target": {
          "id": "syncbusyoverlay",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "platform-shell-legacy-overlay",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.legacy-feedback.reconcilebusyoverlay.ab5c4525",
        "kind": "legacy-feedback",
        "opClass": "foreground-read",
        "target": {
          "id": "showbusyoverlay",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "platform-shell-legacy-overlay",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.legacy-feedback.reconcilebusyoverlay.c60bade7",
        "kind": "legacy-feedback",
        "opClass": "foreground-read",
        "target": {
          "id": "syncbusyoverlay",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "platform-shell-legacy-overlay",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.legacy-feedback.reconcilebusyoverlay.caea0536",
        "kind": "legacy-feedback",
        "opClass": "foreground-read",
        "target": {
          "id": "reconcilebusyoverlay",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "platform-shell-legacy-overlay",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.legacy-feedback.reconcilebusyoverlay.f10a836e",
        "kind": "legacy-feedback",
        "opClass": "foreground-read",
        "target": {
          "id": "syncbusyoverlay",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "platform-shell-legacy-overlay",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.legacy-feedback.showbusyoverlay.5d78734d",
        "kind": "legacy-feedback",
        "opClass": "foreground-read",
        "target": {
          "id": "syncbusyoverlay",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "platform-shell-legacy-overlay",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.legacy-feedback.startbusyoverlaycountdowntimer.31f5d0a2",
        "kind": "legacy-feedback",
        "opClass": "foreground-read",
        "target": {
          "id": "syncbusyoverlay",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "platform-shell-legacy-overlay",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.legacy-feedback.syncbusyoverlay.50dc6796",
        "kind": "legacy-feedback",
        "opClass": "foreground-read",
        "target": {
          "id": "buildbusyoverlaymarkup",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "platform-shell-legacy-overlay",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.legacy-feedback.syncbusyoverlay.bbbe87c7",
        "kind": "legacy-feedback",
        "opClass": "foreground-read",
        "target": {
          "id": "buildbusyoverlaymarkup",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "platform-shell-legacy-overlay",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.legacy-feedback.updatestatusdom.6c43fa09",
        "kind": "legacy-feedback",
        "opClass": "foreground-read",
        "target": {
          "id": "reconcilebusyoverlay",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "platform-shell-legacy-overlay",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.api-admin-archive-exports-limit-30.f4d4800e",
        "kind": "request",
        "opClass": "foreground-read",
        "target": {
          "id": "fetchjson",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "platform-settings",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.api-admin-sessions-active.b9fa0f5b",
        "kind": "request",
        "opClass": "foreground-read",
        "target": {
          "id": "fetchjson",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "platform-settings",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.api-admin-usage-summary-from.407544e1",
        "kind": "request",
        "opClass": "foreground-read",
        "target": {
          "id": "fetchjson",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "platform-settings",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.api-admin-usage-summary-param.06e162f3",
        "kind": "request",
        "opClass": "foreground-read",
        "target": {
          "id": "fetchjson",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "platform-settings",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.api-admin-users-delete-by-email.47886ef0",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "postjsonwithmeta",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "platform-settings",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.api-admin-users-delete-by-email.53c2e439",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "postjsonwithmeta",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "platform-settings",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.api-admin-users-invite.1721ada9",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "postjson",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "platform-settings",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.api-admin-users-param-access.2398f528",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "patchjson",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "platform-settings",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.api-admin-users-param-access.a0abbd3a",
        "kind": "request",
        "opClass": "foreground-read",
        "target": {
          "id": "fetchjson",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "platform-settings",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.api-admin-users-param-delete.7f6ea3c1",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "postjsonwithmeta",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "platform-settings",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.api-admin-users-param-delete.8ca64f7c",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "postjson",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "platform-settings",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.api-admin-users-param-mfa-reset.cc30eee2",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "postjson",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "platform-settings",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.api-admin-users-param-revoke-sessions.46f7e118",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "postjson",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "platform-settings",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.api-admin-users-param-send-setup-email.05935732",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "postjsonwithmeta",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "platform-settings",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.api-admin-users-param-send-setup-email.9ff9e3be",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "postjsonwithmeta",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "platform-settings",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.api-admin-users-param.4f57d928",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "patchjson",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "platform-settings",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.api-admin-users-param.fef9ca50",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "patchjson",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "platform-settings",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.api-admin-users.128d9101",
        "kind": "request",
        "opClass": "foreground-read",
        "target": {
          "id": "fetchjson",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "platform-settings",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.auth-mfa-enroll.d8329af7",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "postjson",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "platform-settings",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.auth-mfa-verify.74afa795",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "postjson",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "platform-settings",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.auth-session.41caba51",
        "kind": "request",
        "opClass": "foreground-read",
        "target": {
          "id": "fetchjson",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "platform-settings",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.auth-session.699c12f9",
        "kind": "request",
        "opClass": "foreground-read",
        "target": {
          "id": "window-fetch",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "platform-shell",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.buildapiclient.d69563da",
        "kind": "request",
        "opClass": "foreground-read",
        "target": {
          "id": "fetchimpl",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "platform-shell",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.buildruntimefetch.94f03c52",
        "kind": "request",
        "opClass": "foreground-read",
        "target": {
          "id": "window-fetch",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "platform-shell",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.fetchjson.18519e24",
        "kind": "request",
        "opClass": "foreground-read",
        "target": {
          "id": "fetch",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "platform-settings",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.installsessionexpiryfetchinterceptor.4a987a10",
        "kind": "request",
        "opClass": "foreground-read",
        "target": {
          "id": "originalfetch",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "platform-shell",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.loadbootmanifestappfromchannel.2a9df2b3",
        "kind": "request",
        "opClass": "route-transition",
        "target": {
          "id": "fetch",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "platform-shell",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.loadbootmanifestappfromchannel.db9f18b0",
        "kind": "request",
        "opClass": "route-transition",
        "target": {
          "id": "fetch",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "platform-shell",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.loadeventsinitial.490b9f97",
        "kind": "request",
        "opClass": "foreground-read",
        "target": {
          "id": "fetchjson",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "platform-settings",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.loadeventsinitial.65dfd794",
        "kind": "request",
        "opClass": "foreground-read",
        "target": {
          "id": "fetchjson",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "platform-settings",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.loadmoreevents.0302efe3",
        "kind": "request",
        "opClass": "foreground-read",
        "target": {
          "id": "fetchjson",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "platform-settings",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.loadmoreevents.9f7b424f",
        "kind": "request",
        "opClass": "foreground-read",
        "target": {
          "id": "fetchjson",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "platform-settings",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.loadmoreusageevents.23e59c47",
        "kind": "request",
        "opClass": "foreground-read",
        "target": {
          "id": "fetchjson",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "platform-settings",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.loadusageeventsinitial.995c7489",
        "kind": "request",
        "opClass": "foreground-read",
        "target": {
          "id": "fetchjson",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "platform-settings",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.patchjson.1cc369e7",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "fetch",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "platform-settings",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.postjson.70b5574c",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "fetch",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "platform-settings",
        "lifecycleRequired": true
      },
      {
        "action": "platform-shell.request.postjsonwithmeta.38a28bb2",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "fetch",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "platform-settings",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.form.account-action.3f5e737d",
        "kind": "form",
        "opClass": "foreground-read",
        "target": {
          "id": "account-action",
          "kind": "control"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre-control",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.form.account-search.7b48b21b",
        "kind": "form",
        "opClass": "foreground-read",
        "target": {
          "id": "account-search",
          "kind": "control"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre-control",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.form.account-wizard.39a6327b",
        "kind": "form",
        "opClass": "foreground-read",
        "target": {
          "id": "account-wizard",
          "kind": "control"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre-control",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.form.capacity.f387efb5",
        "kind": "form",
        "opClass": "user-mutation",
        "target": {
          "id": "capacity",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre-control",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.form.incident.62a9d56f",
        "kind": "form",
        "opClass": "user-mutation",
        "target": {
          "id": "incident",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre-control",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.form.owner-elevation.521a2a98",
        "kind": "form",
        "opClass": "user-mutation",
        "target": {
          "id": "owner-elevation",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre-control",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.form.owner-passkey.8da44891",
        "kind": "form",
        "opClass": "user-mutation",
        "target": {
          "id": "owner-passkey",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre-control",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.form.policy.e992b59d",
        "kind": "form",
        "opClass": "user-mutation",
        "target": {
          "id": "policy",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre-control",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.form.reporting-range.8033405a",
        "kind": "form",
        "opClass": "foreground-read",
        "target": {
          "id": "reporting-range",
          "kind": "control"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre-control",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.form.retry-operation.c77dc659",
        "kind": "form",
        "opClass": "user-mutation",
        "target": {
          "id": "retry-operation",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre-control",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.interaction.logout.9ff57e79",
        "kind": "interaction",
        "opClass": "user-mutation",
        "target": {
          "id": "logout",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre-control",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.interaction.navigate.d7ec0684",
        "kind": "interaction",
        "opClass": "route-transition",
        "target": {
          "id": "navigate",
          "kind": "control"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre-control",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.interaction.open-account.5cc84e69",
        "kind": "interaction",
        "opClass": "foreground-read",
        "target": {
          "id": "open-account",
          "kind": "control"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre-control",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.interaction.refresh.67936ddb",
        "kind": "interaction",
        "opClass": "foreground-read",
        "target": {
          "id": "refresh",
          "kind": "control"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "retain-valid-content",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre-control",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.interaction.reload-account.fbe9a5b1",
        "kind": "interaction",
        "opClass": "foreground-read",
        "target": {
          "id": "reload-account",
          "kind": "control"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre-control",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.legacy-feedback.beginauthpending.212acea7",
        "kind": "legacy-feedback",
        "opClass": "foreground-read",
        "target": {
          "id": "setbusy",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "control-auth-legacy-busy",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.legacy-feedback.beginauthpending.7bb6c6c0",
        "kind": "legacy-feedback",
        "opClass": "foreground-read",
        "target": {
          "id": "setbusy",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "control-auth-legacy-busy",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.legacy-feedback.renderactivescreen.7baf6304",
        "kind": "legacy-feedback",
        "opClass": "foreground-read",
        "target": {
          "id": "renderloadingscreen",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "control-centre-legacy-loader",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.api-platform-v1-activation-accept.4685c746",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "fetch",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-activation",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.api-platform-v1-activation-exchange.d6e74344",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "fetch",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-activation",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.api-platform-v1-activation-session.a816a68c",
        "kind": "request",
        "opClass": "foreground-read",
        "target": {
          "id": "fetch",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "control-activation",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.api-platform-v1-auth-bootstrap-options.fb213b4a",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "api",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-auth",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.api-platform-v1-auth-bootstrap-status.496574aa",
        "kind": "request",
        "opClass": "foreground-read",
        "target": {
          "id": "fetch",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "control-auth",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.api-platform-v1-auth-bootstrap-verify.ada63ced",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "api",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-auth",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.api.08bf0936",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "fetch",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-auth",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.auth-logout.61c4491a",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "fetchimpl",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.auth-passkey-options.bd701391",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "api",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-auth",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.auth-passkey-verify.aa01f9dc",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "api",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-auth",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.auth-recovery-verify.a20dc6c8",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "api",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-auth",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.auth-totp-verify.25e29f36",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "api",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-auth",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.param-accounts-param-actions.5836ecc0",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "requestcontrolcentre",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "domain-idempotent",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.param-accounts-param-billing-checkout.4be4c39b",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "requestcontrolcentre",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "domain-idempotent",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.param-accounts-param-billing-portal.e5049178",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "requestcontrolcentre",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "domain-idempotent",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.param-accounts-param-capacity-simulate.8cc0c04a",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "requestcontrolcentre",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.param-accounts-param-capacity.80ae2f34",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "requestcontrolcentre",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "domain-idempotent",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.param-accounts-param-features-simulate.a1926847",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "requestcontrolcentre",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "domain-idempotent",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.param-accounts-param-features.8f906bcc",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "requestcontrolcentre",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "domain-idempotent",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.param-accounts-param-support-cases-param-acknowledge.3703cd23",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "requestcontrolcentre",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "domain-idempotent",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.param-accounts.15eebed2",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "requestcontrolcentre",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "domain-idempotent",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.param-auth-elevation-options.273928cf",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "requestcontrolcentre",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.param-auth-elevation-verify.7fc15b5d",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "requestcontrolcentre",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.param-auth-passkeys-register-options.24f0d201",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "requestcontrolcentre",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.param-auth-passkeys-register-verify.827ebb96",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "requestcontrolcentre",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.param-auth-session.57836d4c",
        "kind": "request",
        "opClass": "foreground-read",
        "target": {
          "id": "requestcontrolcentre",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "control-centre",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.param-guide-content-actions.e32c89e0",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "requestcontrolcentre",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "domain-idempotent",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.param-guide-content-revisions-param.80024393",
        "kind": "request",
        "opClass": "background-refresh",
        "target": {
          "id": "requestcontrolcentre",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "retain-valid-content",
        "successDestination": "affected-region",
        "announcementOwner": "control-centre",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.param-guide-content.231619c8",
        "kind": "request",
        "opClass": "foreground-read",
        "target": {
          "id": "requestcontrolcentre",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "control-centre",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.param-incidents-param-resolve.1b2ba85e",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "requestcontrolcentre",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "domain-idempotent",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.param-incidents-param.2feb84f4",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "requestcontrolcentre",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "domain-idempotent",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.param-incidents.e782963c",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "requestcontrolcentre",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "domain-idempotent",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.param-operations-param-retry.2cd072ff",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "requestcontrolcentre",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "domain-idempotent",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.param-operations-param.e46ebebe",
        "kind": "request",
        "opClass": "foreground-read",
        "target": {
          "id": "requestcontrolcentre",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "control-centre",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.param-param.2688cb40",
        "kind": "request",
        "opClass": "foreground-read",
        "target": {
          "id": "requestcontrolcentre",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "control-centre",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.param-param.3f2b1665",
        "kind": "request",
        "opClass": "foreground-read",
        "target": {
          "id": "requestcontrolcentre",
          "kind": "region"
        },
        "duplicatePolicy": "latest-result-wins",
        "retryPolicy": "safe-read",
        "cancellationPolicy": "not-applicable",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-region",
        "announcementOwner": "control-centre",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.param-plans-param-capacity-simulate.fc850fd9",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "requestcontrolcentre",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "reconcile-only",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre",
        "lifecycleRequired": true
      },
      {
        "action": "ttoria-control-centre.request.param-plans-param-capacity.e12687d5",
        "kind": "request",
        "opClass": "user-mutation",
        "target": {
          "id": "requestcontrolcentre",
          "kind": "control"
        },
        "duplicatePolicy": "suppress-while-pending",
        "retryPolicy": "domain-idempotent",
        "cancellationPolicy": "presentation-only",
        "dataPolicy": "initial-empty-placeholder-only",
        "successDestination": "affected-control-and-region",
        "announcementOwner": "control-centre",
        "lifecycleRequired": true
      }
    ]
  }
};
const pluginRegistry = {
  "platform.auth-login": { manifest: {"id":"platform.auth-login","name":"Auth Login","version":"1.0.0","apiVersion":"1.0.0","entry":"./index.js","tab":{"label":"Auth","order":1},"nav":{"hidden":true},"requiredCapabilities":[],"publishedCapabilities":[],"featureFlags":[]}, load: loadPluginModule0, prefetch: loadPluginModule0, loading: 'lazy' },
  "control-centre": { manifest: {"id":"control-centre","name":"TToria Control Centre","version":"1.0.0","apiVersion":"1.0.0","entry":"./index.js","tab":{"label":"Control Centre","order":10},"nav":{"hidden":false},"requiredCapabilities":["platform.control.read"],"publishedCapabilities":[],"featureFlags":[]}, module: pluginModule1, loading: 'eager' }
};
(async () => {
  const runtimeBoot = await loadBootManifestAppFromChannel({
    appManifest,
    fallbackBootManifestApp: bootManifestApp
  });
  await runtimeBoot({ appManifest, pluginRegistry, shellRuntimeConfig });
})().catch((error) => {
  console.error('[platform-shell] app bootstrap failed', error);
  throw error;
});